import {Language, PlayerPositionEnum} from "modules/enums";
import headerLogoEn from "assets/images/logos/headerLogo.png";
import headerLogoFr from "assets/images/logos/headerFrLogo.png";
import headerLogoEnMobile from "assets/images/logos/headerLogoMobile.png";
import headerLogoFrMobile from "assets/images/logos/headerLogoFrMobile.png";
import logoEn from "assets/images/logos/allStarLogo.png";
import logoFr from "assets/images/logos/allStarFrLogo.png";
import gameZoneLogoEn from "assets/images/gamezoneLogo.png";
import gameZoneLogoFr from "assets/images/gamezoneLogoFr.png";

const {QB, WR, RB, OL, DL, LB, DB, K, P, ST} = PlayerPositionEnum;

export const LINE_UP = [
	[QB, WR, RB, OL],
	[LB, DL, DB],
	[K, P, ST],
];

export const POSITIONS_ARRAY = [
	{value: PlayerPositionEnum.QB, name: "QB"},
	{value: PlayerPositionEnum.WR, name: "WR"},
	{value: PlayerPositionEnum.RB, name: "RB"},
	{value: PlayerPositionEnum.OL, name: "OL"},
	{value: PlayerPositionEnum.DL, name: "DL"},
	{value: PlayerPositionEnum.LB, name: "LB"},
	{value: PlayerPositionEnum.DB, name: "DB"},
	{value: PlayerPositionEnum.K, name: "K"},
	{value: PlayerPositionEnum.P, name: "P"},
	{value: PlayerPositionEnum.ST, name: "ST"},
];

export const logoLinks = {
	en: "https://cfl.ca/",
	fr: "https://www.lcf.ca/",
};

export const logos = {
	[Language.English]: logoEn,
	[Language.French]: logoFr,
};

export const headerLogos = {
	[Language.English]: headerLogoEn,
	[Language.French]: headerLogoFr,
};

export const headerLogosMobile = {
	[Language.English]: headerLogoEnMobile,
	[Language.French]: headerLogoFrMobile,
};

export const gameZoneLogos = {
	[Language.English]: gameZoneLogoEn,
	[Language.French]: gameZoneLogoFr,
};

export const MAX_TEAM_COUNT = 3;
export const MAX_VOTE_COUNT = 3;

export const TEAM_KEY = "all_star_team";
export const FAN_VOTE_KEY = "fan_vote";
